import script from "./TourEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TourEdit.vue?vue&type=script&setup=true&lang=js"

import "./TourEdit.vue?vue&type=style&index=0&id=4e016bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e016bdc"]])

export default __exports__